import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { SampleService } from '../../../core/http/sample.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SelfServiceService } from '../../../core/http/self-service.service';

@Component({
  selector: 'app-create-appointment',
  templateUrl: './create-appointment.component.html',
  styleUrls: ['./create-appointment.component.scss'],
})
export class CreateAppointmentComponent implements OnInit {
  isLoading = false;
  Errors = null;
  mode = null;
  id = localStorage.getItem('id');
  Success = null;
  return;
  drs: any = [];
  branches: any = [];
  UserId;
  UserEmail;
  item;
  drVisible: boolean = false;
  searchRef;
  TotalAmount;
  data: any = [];
  opdPrice: any = [];
  AppointmentDetails: any[];
  Visible;
  searchItem;
  patient;
  items;
  removable = true;

  sex: '';
  maritalStatus: '';
  age: '';
  address: '';
  refDr: '';
  DOB: '';
  SOCID: '';
  comment: '';
  occupatiobn: '';
  noOfChildren = '';
  name = '';
  refDrs = '';
  number = '';
  title = '';

  stateForm = new FormGroup({
    Id: new FormControl(''),
    UserId: new FormControl(''),
    Name: new FormControl(''),
    UserEmail: new FormControl(''),
    Title: new FormControl(''),
    ScheduleDate: new FormControl(''),
    ScheduleTime: new FormControl(''),
    Comment: new FormControl(''),
    TotalAmount: new FormControl(''),
    IsPaid: new FormControl(''),
    RefNo: new FormControl(''),
    IsSynched: new FormControl(''),
    OnlineBranchId: new FormControl(''),
    AppointmentDetails: new FormControl(''),
    BranchName: new FormControl(''),
  });

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public sample: SampleService,
    private self: SelfServiceService
  ) {}

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    console.log(this.stateForm.value);
    let comment = {
      sex: this.sex,
      maritalStatus: this.maritalStatus,
      age: this.age,
      address: this.address,
      DOB: this.DOB,
      comment: this.comment,
      occupatiobn: this.occupatiobn,
      noOfChildren: this.noOfChildren,
      name: this.name,
      refDrs: this.refDrs,
      number: this.number,
      OnlineBranchId: this.stateForm.value.OnlineBranchId,
      title: this.title,
    };

    let AppointmentDetails: any = this.AppointmentDetails;
    const {
      Id,
      UserId,
      Name,
      UserEmail,
      Title,
      ScheduleDate,
      ScheduleTime,
      Comment,
      TotalAmount,
      IsPaid,
      RefNo,
      IsSynched,
      OnlineBranchId,
      BranchName,
    } = this.stateForm.value;
    this.self
      .postAppointment(
        Id,
        UserId,
        Name,
        UserEmail,
        Title,
        ScheduleDate,
        ScheduleTime,
        JSON.stringify(comment),
        TotalAmount,
        IsPaid,
        RefNo,
        IsSynched,
        OnlineBranchId,
        AppointmentDetails,
        BranchName
      )
      .subscribe(
        (resSuccess) => {
          this.return = resSuccess;
          this.isLoading = false;
          console.log(resSuccess);

          if (this.return.success) {
            this.closeModal();
            this._snackBar.open('Sent Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            console.log(this.return);
            this._snackBar.open(this.return.message, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isLoading = false;
          this._snackBar.open('Error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }
  closeModal() {
    this.modal.closeModal();
  }

  formatData() {
    this.stateForm.patchValue({
      TotalAmount: this.opdPrice.reduce(
        (accum, item) => accum + item.service_price,
        0
      ),
    });
  }

  addItems(items) {
    this.AppointmentDetails = this.opdPrice.map((item) => ({
      Id: null,
      AppointmentId: null,
      ItemOfServiceId: item.id,
      ItemOfServiceName: item.name,
      IsOPD: item.is_opd,
      Amount: item.service_price,
      Dept: item.dept_name,
      SubDept: item.sub_dept_name,
    }));
    console.log(this.AppointmentDetails);
  }

  refchg(value) {
    if (value == '') {
      this.drVisible = false;
    } else {
      this.drVisible = true;
    }
    this.searchRef = this.searchItem.filter(
      (t) => t.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  addItem(item) {
    let index = this.searchItem.indexOf(item);
    item.selected = true;
    this.searchItem[index] = item;

    if (item.is_opd) {
      this.self.getItemOPD(item.id).subscribe(
        (resSuccess) => {
          // this.opdPrice.push(resSuccess)
          this.opdPrice.push.apply(this.opdPrice, resSuccess);
          this.formatData();
          this.addItems(item);
        },
        (resErr) => {
          this.isLoading = false;
          // this.Errors = resErr;
        }
      );
    } else {
      // this.data.push(item);
      this.opdPrice.push(item);
      this.formatData();
      this.addItems(item);
      // console.log(this.stateForm.value)
    }
  }

  deleteItem(item) {
    // let index = this.searchItem.indexOf(item)
    //     item.selected = false
    //     this.searchItem[index] = item
    this.opdPrice = this.opdPrice.filter((t) => t.id !== item.id);
    this.data = this.data.filter((t) => t.id !== item.id);
    this.formatData();
    this.addItems(item);
  }

  ngOnInit(): void {
    this.self.getBranch().subscribe(
      (resSuccess) => {
        this.branches = resSuccess;
        console.log(this.branches);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );

    this.self.getPatient(this.id).subscribe(
      (resSuccess: any) => {
        this.stateForm.patchValue({
          UserId: resSuccess[0].Employee_id,
          UserEmail: resSuccess[0].Email_id,
        });
        console.log(this.stateForm.value);
      },
      (resErr) => {
        this.isLoading = false;
      }
    );

    this.self.getBillItem().subscribe(
      (resSuccess: any) => {
        this.items = resSuccess.map((item) => ({
          selected: false,
          Daily: item.Daily,
          Methodology: item.Methodology,
          NABL_Accredited: item.NABL_Accredited,
          dept_id: item.dept_id,
          dept_name: item.dept_name,
          direct_revenue: item.direct_revenue,
          doctor_reqd: item.doctor_reqd,
          id: item.id,
          is_opd: item.is_opd,
          name: item.name,
          one_time: item.one_time,
          price_editable: item.price_editable,
          profile: item.profile,
          release_dr_fee_when_unsettled: item.release_dr_fee_when_unsettled,
          report_type: item.report_type,
          service_price: item.service_price,
          soc_id: item.soc_id,
          status: item.status,
          sub_dept_id: item.sub_dept_id,
          sub_dept_name: item.sub_dept_name,
        }));
        this.searchItem = this.items;

        this.isLoading = false;
        console.log(this.searchItem);
      },
      (resErr) => {
        this.isLoading = false;
        // this.Errors = resErr;
      }
    );
  }
}
